import { render, staticRenderFns } from "./BikeStats.vue?vue&type=template&id=32b46839&scoped=true&lang=pug"
import script from "./BikeStats.vue?vue&type=script&lang=js"
export * from "./BikeStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b46839",
  null
  
)

export default component.exports